import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import getOrders from '../../features/orders/selectors';
import { fetchOrders, resetOrdersState } from '../../features/orders/ordersSlice';
import { RootState } from '../../app/store';
import { OrdersState } from '../../features/orders/types';
import { ErrorMessage } from '../../const';
import OrdersPage from './OrdersPage';
import ThrobberForPage from '../../components/ThrobberForPage/ThrobberForPage';
import ErrorPage from '../ErrorPage/ErrorPage';

type Props = {
  orders: OrdersState;
  fetchOrdersByApi: () => void;
  resetOrdersStateApi: () => void;
};

const OrdersPageContainer: React.FC<Props> = (props) => {
  const { orders, fetchOrdersByApi, resetOrdersStateApi } = props;
  const { data, isLoading, error } = orders;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    fetchOrdersByApi();
    setIsMounted(true);

    return () => resetOrdersStateApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isMounted) {
    if (!isEmpty(error)) {
      return <ErrorPage message={ErrorMessage.COMMON_ERROR} />;
    }

    if (isLoading) {
      return <ThrobberForPage />;
    }

    return <OrdersPage orders={data} fetchOrdersByApi={fetchOrdersByApi} />;
  }

  return null;
};

const mapStateToProps = (state: RootState) => ({
  orders: getOrders(state),
});

const dispatchProps = {
  fetchOrdersByApi: fetchOrders,
  resetOrdersStateApi: resetOrdersState,
};

export default connect(mapStateToProps, dispatchProps)(OrdersPageContainer);
